import { Component, OnInit, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ViewUpdateTprApiService } from 'src/modules/api';

interface TprDeleteData {
  toolId: number;
  fixtureBuilt: boolean;
}

enum TprDeleteOptions {
  PRE_SALABLE,
  POST_SALABLE,
  SOURCING_CHANGE,
  END_OF_PRODUCTION
}

@Component({
  selector: 'tpr-delete',
  templateUrl: './tpr-delete.component.html',
  styleUrls: ['./tpr-delete.component.scss'],
})
export class TprDeleteComponent {

  readonly TprDeleteOptions = TprDeleteOptions;

  form = new UntypedFormGroup({
    selection: new UntypedFormControl(null),
    date: new UntypedFormControl(null, Validators.required)
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) readonly data: TprDeleteData,
    private readonly dialog: MatDialogRef<TprDeleteComponent>,
    private readonly service: ViewUpdateTprApiService
  ) { }

  canDelete(): boolean {
    const selection = this.form.get('selection').value;
    return selection === null || selection === TprDeleteOptions.PRE_SALABLE || selection === TprDeleteOptions.SOURCING_CHANGE;
  }

  deletionDate(): string {
    return `January 1, ${this.form.get('date').value.getFullYear() + 16}`;
  }

  remove(): void {
    const selection = this.form.get('selection').value;
    switch (selection) {
      case null:
      case TprDeleteOptions.PRE_SALABLE:
      case TprDeleteOptions.POST_SALABLE:
        this.permDelete();
        break;
      case TprDeleteOptions.SOURCING_CHANGE:
        this.resource();
    }
  }

  permDelete(): void {
    this.service.deleteTool(this.data.toolId)
      .subscribe(() => this.dialog.close(true));
  }

  resource(): void {
    this.service.updateTprResource(this.data.toolId)
        .subscribe(() => this.dialog.close(true));
  }
}
